<div class="naplo-wrap">
  <div *ngIf="!aktiv.ugyfelId" class="ures">Válassz ügyfelet az Ügyfelek menüben a dokumentumtár megnyitásához.</div>

  <ng-container *ngIf="aktiv.ugyfelId">
    <!-- Az e-mail elkapó saját menüpontja a Szervíz alatt van – itt csak a cím emlékeztetőül. -->
    <div class="dok-email-sor">
      <ion-icon name="mail-outline"></ion-icon>
      <span>Számla e-mailben: <b>{{ emailCim || ('&lt;adószám&gt;@' + emailDomain) }}</b> – a mellékletek ide kerülnek.</span>
      <a routerLink="/naplo/email-elkapo">Beérkezett levelek, beállítás →</a>
    </div>

    <!-- Feltöltés -->
    <div class="feltolto">
      <input #zipInput type="file" accept=".zip" hidden (change)="fajlValaszt($event, true)">
      <input #pdfInput type="file" accept="application/pdf" hidden (change)="fajlValaszt($event, false)">
      <ion-button (click)="zipInput.click()" [disabled]="feltoltes">
        <ion-icon slot="start" name="archive"></ion-icon> ZIP feltöltése (auto-párosítás)
      </ion-button>
      <ion-button fill="outline" (click)="pdfInput.click()" [disabled]="feltoltes">
        <ion-icon slot="start" name="document-attach"></ion-icon> Egyedi PDF
      </ion-button>
      <ion-button fill="outline" color="medium" (click)="ujraParosit()" [disabled]="ujraParositFut || !parositlanSzam">
        <ion-spinner *ngIf="ujraParositFut" name="dots"></ion-spinner>
        <span *ngIf="!ujraParositFut"><ion-icon slot="start" name="git-compare"></ion-icon> Újrapárosítás ({{ parositlanSzam }})</span>
      </ion-button>
      <ion-spinner *ngIf="feltoltes" name="dots"></ion-spinner>
      <span class="halvany">A ZIP-ben lévő PDF-eket a rendszer a számlaszám alapján a könyvelési tételekhez párosítja.</span>
    </div>

    <!-- Szűrő -->
    <div class="dok-szurosor">
      <!-- A számlálók a KERESÉSSEL és az ÉVVEL szűrt halmazra vonatkoznak, hogy egyezzenek a táblával. -->
      <ion-segment [(ngModel)]="szuro" class="dok-szuro">
        <ion-segment-button value="mind"><ion-label>Mind ({{ osszesSzam }})</ion-label></ion-segment-button>
        <ion-segment-button value="parositott"><ion-label>Párosított ({{ osszesSzam - parositlanSzam }})</ion-label></ion-segment-button>
        <ion-segment-button value="parositlan"><ion-label>Párosítatlan ({{ parositlanSzam }})</ion-label></ion-segment-button>
      </ion-segment>
      <ion-item lines="none" class="dok-ev">
        <ion-label>Év</ion-label>
        <ion-select [(ngModel)]="evSzuro" interface="popover">
          <ion-select-option [value]="'mind'">Összes év</ion-select-option>
          <ion-select-option *ngFor="let e of evek" [value]="e">{{ e }}</ion-select-option>
        </ion-select>
      </ion-item>
      <!-- Szabadszavas keresés: fájlnév, számlaszám, partner, adószám, dátum és a párosított tétel
           adatai között. Több szó = ÉS kapcsolat, ékezet- és kisbetű-független. -->
      <ion-searchbar class="dok-kereso" [(ngModel)]="kereses" [debounce]="150"
                     placeholder="Keresés: fájlnév, számlaszám, partner, adószám…"
                     showClearButton="focus"></ion-searchbar>
    </div>

    <div *ngIf="!szurt.length" class="ures">Nincs dokumentum ebben a nézetben.</div>

    <div class="tabla-wrap" *ngIf="szurt.length">
    <table class="naplo-tabla dok-tabla">
      <thead>
        <!-- Partner: a számláról kiolvasva, könyveléskor a kiválasztott partnerrel pótolva -->
        <tr><th>Fájl</th><th>Méret</th><th>Számlaszám</th><th>Kelte</th><th>Partner</th><th>Párosított tétel</th><th>Feltöltve</th><th class="jobb muvelet-oszlop">Műveletek</th></tr>
      </thead>
      <tbody>
        <tr *ngFor="let d of szurt">
          <td>
            <ion-icon name="document-text" color="danger"></ion-icon>
            <a class="dok-nev" [title]="d.fajl_nev" (click)="pdf(d)">{{ d.fajl_nev }}</a>
            <ion-badge *ngIf="d.forras === 'zip'" color="medium">ZIP</ion-badge>
          </td>
          <td>{{ meret(d.meret) }}</td>
          <td>{{ d.szamlaszam || '—' }}</td>
          <td style="white-space:nowrap">{{ d.szamla_datum || '—' }}</td>
          <td>
            <span *ngIf="d.partner">{{ d.partner }}</span>
            <span *ngIf="d.partner_adoszam" class="halvany" style="font-size:.8rem"> · {{ d.partner_adoszam }}</span>
            <div *ngIf="cim(d)" class="halvany" style="font-size:.78rem">{{ cim(d) }}</div>
            <span *ngIf="!d.partner && !d.partner_adoszam" class="halvany">—</span>
          </td>
          <td>
            <span *ngIf="d.parositva" class="parositott">
              <ion-icon name="checkmark-circle" color="success"></ion-icon>
              {{ d.tetel_szamlaszam || d.szamlaszam }}<span class="halvany" *ngIf="d.tetel_partner"> · {{ d.tetel_partner }}</span>
            </span>
            <span *ngIf="!d.parositva" class="parositlan-jel"><ion-icon name="alert-circle" color="warning"></ion-icon> nincs párosítva</span>
          </td>
          <td class="halvany">{{ d.feltoltve }}</td>
          <td class="jobb muveletek muvelet-oszlop">
            <ion-button size="small" fill="clear" (click)="pdf(d)" title="Megnyitás"><ion-icon slot="icon-only" name="eye"></ion-icon></ion-button>
            <ion-button *ngIf="kettos" size="small" fill="clear" color="success" [disabled]="konyvBetolt" (click)="konyvelDok(d)" title="Könyvelés (kettős bizonylat – devizás is)">
              <ion-spinner *ngIf="konyvBetolt && konyvDok?.id === d.id" name="dots"></ion-spinner>
              <ion-icon *ngIf="!(konyvBetolt && konyvDok?.id === d.id)" slot="icon-only" name="create"></ion-icon>
            </ion-button>
            <ion-button size="small" fill="clear" color="tertiary" [disabled]="felismerFut === d.id" (click)="felismeresUjra(d)" title="Felismerés újra (szöveg, ha szkennelt OCR)">
              <ion-spinner *ngIf="felismerFut === d.id" name="dots"></ion-spinner>
              <ion-icon *ngIf="felismerFut !== d.id" slot="icon-only" name="scan"></ion-icon>
            </ion-button>
            <ion-button size="small" fill="clear" color="primary" *ngIf="!d.parositva" (click)="parosit(d)" title="Párosítás"><ion-icon slot="icon-only" name="link"></ion-icon></ion-button>
            <ion-button size="small" fill="clear" color="medium" *ngIf="d.parositva" (click)="levalaszt(d)" title="Párosítás megszüntetése"><ion-icon slot="icon-only" name="unlink"></ion-icon></ion-button>
            <ion-button size="small" fill="clear" color="danger" (click)="torol(d)" title="Törlés"><ion-icon slot="icon-only" name="trash"></ion-icon></ion-button>
          </td>
        </tr>
      </tbody>
    </table>
    </div>
  </ng-container>
</div>

<!-- Közvetlen könyvelés (kettős bizonylat) a dokumentumból – devizás is -->
<ion-modal #konyvModal class="naplo-wide-modal">
  <ng-template>
    <ion-header><ion-toolbar style="--background:var(--naplo);--color:#fff">
      <ion-title>{{ konyvSzerk?.id ? 'Bizonylat módosítása' : 'Könyvelés' }} – {{ konyvSzerk?.naplo_tipus || 'szállító' }} napló</ion-title>
      <ion-buttons slot="end"><ion-button (click)="konyvModal.dismiss()">Bezár</ion-button></ion-buttons>
    </ion-toolbar></ion-header>
    <ion-content class="ion-padding" *ngIf="konyvSzerk">
      <!-- A könyvelés forrás-PDF-je bármikor megnyitható külön ablakban (számlakép ellenőrzéshez) -->
      <div *ngIf="konyvDok" style="display:flex; align-items:center; gap:8px; margin:0 0 8px; flex-wrap:wrap">
        <span class="halvany">Dokumentum: <b>{{ konyvDok.fajl_nev }}</b></span>
        <ion-button size="small" fill="outline" color="tertiary" (click)="pdf(konyvDok)">
          <ion-icon slot="start" name="document-text"></ion-icon>Számlakép megnyitása
        </ion-button>
      </div>
      <!-- NÉGY dátum a PDF-ből kiolvasva: kelt / teljesítés / ÁFA-teljesítés / fizetési határidő -->
      <ion-grid><ion-row>
        <ion-col size="6" sizeMd="3"><ion-item><ion-input type="date" label="Kelt (bizonylat dátuma)" labelPlacement="stacked" [(ngModel)]="konyvSzerk.datum" (ionChange)="arfolyamFrissit()"></ion-input></ion-item></ion-col>
        <ion-col size="6" sizeMd="3"><ion-item><ion-input type="date" label="Teljesítés" labelPlacement="stacked" [(ngModel)]="konyvSzerk.teljesites"></ion-input></ion-item></ion-col>
        <ion-col size="6" sizeMd="3"><ion-item><ion-input type="date" label="ÁFA-teljesítés" labelPlacement="stacked" [(ngModel)]="konyvSzerk.afa_datum"></ion-input></ion-item></ion-col>
        <ion-col size="6" sizeMd="3"><ion-item><ion-input type="date" label="Fizetési határidő" labelPlacement="stacked" [(ngModel)]="konyvSzerk.hatarido"></ion-input></ion-item></ion-col>
      </ion-row><ion-row>
        <ion-col size="12" sizeMd="3"><ion-item><ion-input label="Bizonylatszám" labelPlacement="stacked" [(ngModel)]="konyvSzerk.bizonylatszam"></ion-input></ion-item></ion-col>
        <!-- Partner: a partnertörzsből választva (kereshető), nem szabad szöveg -->
        <ion-col size="12" sizeMd="5">
          <ion-item><ion-label position="stacked">Partner</ion-label>
            <div style="display:flex; align-items:center; width:100%; padding-top:4px">
              <ion-input readonly [value]="konyvSzerk.partner_nev || '– nincs –'" (click)="partnerPickerNyit()" style="cursor:pointer"></ion-input>
              <ion-button size="small" fill="clear" (click)="partnerPickerNyit()" title="Választás a törzsből"><ion-icon slot="icon-only" name="search"></ion-icon></ion-button>
              <ion-button size="small" fill="clear" color="medium" *ngIf="konyvSzerk.partner_nev" (click)="partnerTorles()"><ion-icon slot="icon-only" name="close"></ion-icon></ion-button>
            </div>
          </ion-item>
          <ion-note *ngIf="partnerHianyzik" color="danger" style="font-size:.78rem; padding-left:14px">
            Nincs a törzsben.
            <a style="color:var(--naplo); cursor:pointer; font-weight:600" (click)="partnerFelvesz()">Létrehozás „{{ konyvSzerk.partner_nev }}" néven</a>
          </ion-note>
        </ion-col>
        <ion-col size="12" sizeMd="4"><ion-item><ion-input label="Megnevezés" labelPlacement="stacked" [(ngModel)]="konyvSzerk.megnevezes"></ion-input></ion-item></ion-col>
      </ion-row></ion-grid>

      <!-- Devizás tétel: az összegeket devizában adod meg, MNB-középárfolyammal HUF-ra váltjuk -->
      <ion-grid style="padding-top:0"><ion-row class="ion-align-items-center">
        <ion-col size="12" sizeMd="3"><ion-item lines="none"><ion-toggle [(ngModel)]="konyvSzerk.devizas" (ngModelChange)="devizaValt()">Devizás tétel</ion-toggle></ion-item></ion-col>
        <ng-container *ngIf="konyvSzerk.devizas">
          <ion-col size="4" sizeMd="2"><ion-item><ion-select label="Pénznem" labelPlacement="stacked" [(ngModel)]="konyvSzerk.deviza" (ionChange)="arfolyamFrissit()">
            <ion-select-option *ngFor="let p of penznemek" [value]="p">{{ p }}</ion-select-option>
          </ion-select></ion-item></ion-col>
          <ion-col size="5" sizeMd="3"><ion-item><ion-input type="number" label="MNB árfolyam (HUF)" labelPlacement="stacked" [(ngModel)]="konyvSzerk.arfolyam" placeholder="auto"></ion-input></ion-item></ion-col>
          <ion-col size="3" sizeMd="2"><ion-button size="small" fill="outline" (click)="arfolyamFrissit()" title="MNB árfolyam frissítése a bizonylat dátumára"><ion-icon slot="icon-only" name="refresh-outline"></ion-icon></ion-button></ion-col>
          <ion-col size="12" sizeMd="2"><div style="font-size:.8rem;color:#64748b">HUF összesen:<br><b style="color:#134e4a">{{ hufErtek(foOsszeg) | number:'1.0-0' }} Ft</b></div></ion-col>
        </ng-container>
      </ion-row></ion-grid>

      <div class="javaslat-sav" *ngIf="konyvJavaslatok.length">
        <span class="cimke">Javasolt számlák:</span>
        <ion-chip *ngFor="let j of konyvJavaslatok" color="success" outline (click)="javaslatAlkalmaz(j)">
          <ion-label><b>{{ j.szamlaszam }}</b> {{ j.nev }} <small *ngIf="j.gyakorisag">({{ j.gyakorisag }}×)</small></ion-label>
        </ion-chip>
      </div>

      <!-- FŐLÁB: a szállító fix könyvelési lába (4541); minden sor ezzel szemben áll, az összegét/oldalát auto-egyenlítjük -->
      <div class="foszamla-sav">
        <ion-icon name="git-merge-outline" color="primary"></ion-icon>
        <span class="cimke">Főláb:</span>
        <div class="szla-mezo">
          <ion-input fill="outline" [(ngModel)]="konyvSzerk.foszamla" placeholder="főkönyvi szám"></ion-input>
          <ion-button fill="clear" size="small" (click)="nyitKonyvSzla({ fo: true })" title="Választás a törzsből"><ion-icon slot="icon-only" name="list"></ion-icon></ion-button>
        </div>
        <span class="fonev">{{ szamlaNev(konyvSzerk.foszamla) || '—' }}</span>
        <span class="foosszeg"><b>{{ foOldal }}</b> {{ foOsszeg | number:'1.0-0' }}</span>
      </div>

      <div class="kettos-sorok uj">
        <div class="sor-fej"><span>Főkönyvi szám</span><span>Megnevezés</span><span>Összeg</span><span>T/K</span><span>ÁFA %</span><span></span></div>
        <div class="sor" *ngFor="let s of konyvSzerk.sorok; let i = index">
          <div class="szla-mezo">
            <ion-input fill="outline" [(ngModel)]="s.szamlaszam" placeholder="pl. 511"></ion-input>
            <ion-button fill="clear" size="small" (click)="nyitKonyvSzla({ sor: s })" title="Választás a törzsből"><ion-icon slot="icon-only" name="list"></ion-icon></ion-button>
          </div>
          <ion-input fill="outline" [(ngModel)]="s.megnevezes" [placeholder]="szamlaNev(s.szamlaszam) || 'megnevezés'"></ion-input>
          <ion-input fill="outline" type="number" [(ngModel)]="s.osszeg" placeholder="0"></ion-input>
          <ion-input fill="outline" class="tk-mezo" [(ngModel)]="s.oldal" maxlength="1" (ionInput)="s.oldal = (s.oldal || '').toUpperCase()" placeholder="T/K"></ion-input>
          <ion-input fill="outline" type="number" [(ngModel)]="s.afa_kulcs" placeholder=""></ion-input>
          <ion-button fill="clear" color="danger" size="small" (click)="sorTorol(i)"><ion-icon slot="icon-only" name="close"></ion-icon></ion-button>
        </div>
      </div>
      <ion-button fill="clear" size="small" (click)="sorHozzaad()"><ion-icon slot="start" name="add"></ion-icon>Sor hozzáadása</ion-button>

      <!-- ÁFA-segéd: egyenes és FORDÍTOTT adózás; nem áfaalany ügyfélnél csak a fizetendő oldal
           keletkezik, és a költséget bruttóra emeljük (az ÁFA nem levonható). -->
      <div class="afa-seged">
        <span class="cimke">ÁFA-segéd:</span>
        <ion-input fill="outline" type="number" [(ngModel)]="afaSeged.alap" placeholder="nettó alap"></ion-input>
        <ion-input fill="outline" type="number" [(ngModel)]="afaSeged.kulcs" placeholder="%"></ion-input>
        <ion-checkbox [(ngModel)]="afaSeged.fordit" labelPlacement="end">Fordított ÁFA</ion-checkbox>
        <ion-button size="small" fill="outline" (click)="afaSorokHozzaad()">ÁFA-sorok</ion-button>
      </div>
      <ion-note *ngIf="!konyvAfas" color="medium" style="display:block; font-size:.78rem; padding:0 4px 6px">
        Az ügyfél <b>nem áfaalany</b> (adószám középső jegye 1) – a beszerzést <b>bruttóban</b> könyveljük,
        levonható ÁFA-sor nélkül. A fordított adó le nem vonható, ezért <b>ráfordításként</b> könyvelődik.
      </ion-note>
      <!-- A fordított ÁFA ÖNÁLLÓ bizonylat: nem a szállítói sorral áll szemben -->
      <div *ngIf="forditSorok.length" class="afa-seged" style="background:#fef3c7; border-color:#fcd34d">
        <span class="cimke" style="color:#92400e">Fordított ÁFA – {{ forditMeglevo ? 'külön bizonylaton könyvelve' : 'külön bizonylat készül' }} ({{ forditAfa | number:'1.0-0' }}):</span>
        <span style="font-size:.82rem">
          <ng-container *ngFor="let s of forditSorok; let i = index">{{ i ? ' · ' : '' }}<b>{{ s.szamlaszam }}</b> {{ s.tartozik ? 'T ' + (s.tartozik | number:'1.0-2') : 'K ' + (s.kovetel | number:'1.0-2') }}</ng-container>
        </span>
        <ion-icon *ngIf="forditMeglevo" name="checkmark-circle" color="success" title="Már elkészült bizonylat"></ion-icon>
        <ion-button *ngIf="!forditMeglevo" size="small" fill="clear" color="danger" (click)="forditTorol()"><ion-icon slot="icon-only" name="close"></ion-icon></ion-button>
      </div>

      <div class="egyensuly" [class.ok]="egyensulyban" [class.hiba]="!egyensulyban">
        <span>Tartozik: <b>{{ tSum | number:'1.0-0' }}</b></span>
        <span>Követel: <b>{{ kSum | number:'1.0-0' }}</b></span>
        <span>{{ egyensulyban ? '✓ egyensúlyban' : '✗ nincs egyensúlyban' }}</span>
      </div>

      <ion-button expand="block" style="--background:var(--naplo)" [disabled]="!egyensulyban || konyvMentFut" (click)="konyvMentes()">
        <ion-spinner *ngIf="konyvMentFut" name="dots"></ion-spinner>
        <span *ngIf="!konyvMentFut"><ion-icon slot="start" name="save"></ion-icon>Könyvelés</span>
      </ion-button>
    </ion-content>
  </ng-template>
</ion-modal>

<!-- Főkönyvi szám választó a törzsből (számlatükör) -->
<ion-modal #konyvSzlaValaszto class="naplo-wide-modal">
  <ng-template>
    <ion-header><ion-toolbar style="--background:var(--naplo);--color:#fff">
      <ion-title>Főkönyvi szám választása</ion-title>
      <ion-buttons slot="end"><ion-button (click)="konyvSzlaValaszto.dismiss()">Bezár</ion-button></ion-buttons>
    </ion-toolbar></ion-header>
    <ion-content class="ion-padding">
      <ion-searchbar placeholder="Keresés szám vagy név szerint…" [(ngModel)]="konyvSzlaKereso" debounce="120"></ion-searchbar>
      <div *ngIf="!konyvSzlaTalalat.length" class="ures">Nincs találat.</div>
      <table class="naplo-tabla" *ngIf="konyvSzlaTalalat.length">
        <thead><tr><th>Szám</th><th>Megnevezés</th><th>Típus</th><th></th></tr></thead>
        <tbody>
          <tr *ngFor="let x of konyvSzlaTalalat">
            <td><b>{{ x.szamlaszam }}</b></td><td>{{ x.nev }}</td><td class="halvany">{{ x.tipus }}</td>
            <td class="jobb"><ion-button size="small" (click)="valasztKonyvSzla(x)"><ion-icon slot="start" name="checkmark"></ion-icon>Választ</ion-button></td>
          </tr>
        </tbody>
      </table>
    </ion-content>
  </ng-template>
</ion-modal>

<!-- Kereshető partner-választó (a könyvelő modalhoz) -->
<ion-modal #partnerPicker class="kozep-modal">
  <ng-template>
    <ion-header><ion-toolbar style="--background:var(--naplo);--color:#fff">
      <ion-title>Partner kiválasztása</ion-title>
      <ion-buttons slot="end"><ion-button (click)="partnerPicker.dismiss()">Bezár</ion-button></ion-buttons>
    </ion-toolbar></ion-header>
    <ion-content>
      <ion-searchbar placeholder="Keresés név vagy adószám szerint…" [(ngModel)]="partnerKereso" [debounce]="150"></ion-searchbar>
      <ion-list>
        <ion-item button *ngFor="let p of szurtPartnerek" (click)="partnerValaszt(p)">
          <ion-label>
            <h3>{{ p.rovid_nev || p.nev }}</h3>
            <p *ngIf="p.rovid_nev && p.nev !== p.rovid_nev">{{ p.nev }}</p>
            <p *ngIf="p.adoszam">Adószám: {{ p.adoszam }}</p>
          </ion-label>
        </ion-item>
        <ion-item *ngIf="!szurtPartnerek.length" lines="none"><ion-label color="medium">Nincs találat.</ion-label></ion-item>
      </ion-list>
      <div class="ion-padding" *ngIf="partnerKereso.trim()">
        <ion-button expand="block" fill="outline" (click)="partnerFelvesz(partnerKereso)">
          <ion-icon slot="start" name="add"></ion-icon> Új partner: „{{ partnerKereso }}"
        </ion-button>
      </div>
    </ion-content>
  </ng-template>
</ion-modal>

<!-- Manuális párosító modal -->
<ion-modal #parosModal class="naplo-wide-modal">
  <ng-template>
    <ion-header><ion-toolbar color="primary">
      <ion-title>Párosítás tételhez</ion-title>
      <ion-buttons slot="end"><ion-button (click)="parosModal.dismiss()">Bezárás</ion-button></ion-buttons>
    </ion-toolbar></ion-header>
    <ion-content class="ion-padding">
      <p class="halvany" *ngIf="parosDoc">Dokumentum: <b>{{ parosDoc.fajl_nev }}</b></p>
      <ion-searchbar placeholder="Keresés számlaszám / partner / dátum szerint…" [(ngModel)]="tetelKeres" (ionInput)="tetelKereses()" debounce="250"></ion-searchbar>
      <div *ngIf="!tetelTalalat.length" class="ures">Nincs találat. Írj be számlaszámot vagy partnert.</div>
      <table class="naplo-tabla" *ngIf="tetelTalalat.length">
        <thead><tr><th>Számlaszám</th><th>Partner</th><th>Dátum</th><th class="num">Bruttó</th><th></th></tr></thead>
        <tbody>
          <tr *ngFor="let t of tetelTalalat">
            <td>{{ t.szamlaszam || '—' }} <ion-icon *ngIf="t.van_kep" name="image" color="medium" title="Már van képe"></ion-icon></td>
            <td>{{ t.partner || '—' }}</td>
            <td>{{ t.datum }}</td>
            <td class="num">{{ t.brutto | number:'1.0-0' }}</td>
            <td class="jobb"><ion-button size="small" (click)="valaszt(t)"><ion-icon slot="start" name="link"></ion-icon> Párosít</ion-button></td>
          </tr>
        </tbody>
      </table>
    </ion-content>
  </ng-template>
</ion-modal>
